const formatMoney = valueDecimal => {
  // const isNumber = typeof valueDecimal === 'number' && !isNaN(valueDecimal)
  // const isInteger = isNumber && Number.isInteger(valueDecimal)
  // const isFloat = isNumber && !isInteger

  // const value = isInteger ? valueDecimal : parseFloat(valueDecimal).toFixed(2)
  // return valueDecimal.toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' })

  // const value = typeof valueDecimal === 'string' ? parseFloat(valueDecimal).toFixed(2) : valueDecimal

  const value = typeof valueDecimal === 'string' ? parseFloat(valueDecimal) : valueDecimal

  return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' })
}

export default formatMoney
